import { Component, OnInit } from '@angular/core';
import { UiTable } from "../../../../../components/ui/table/table.component";
import { UiButtonComponent } from '../../../../../components/button/button.component';
import { ModalComponent } from "../../../../../components/modal/modal.component";
import { TableTypeModePassation } from '../../../../../data/schemas/table.schema';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AppService } from '../../../../../core/app.service';
import { LoaderComponent } from "../../../../../components/ui/loader/loader.component";
import { Input } from '../../../../../components/forms/input/input';
import { TypeModePassationMarcheService } from '../../../../../services/typepassation.service';
import { TypeModePassationReq } from '../../../../../data/http/requests/typepassation.req';
import { transformString } from '../../../../../utils/helpers';
import { MatIcon } from "@angular/material/icon";
import { ConfirmDialogComponent } from '../../../../../components/ui/Confirmdialog/Confirmdialog.component';
import { loaderIntervantion } from '../../../../../components/ui/loaderIntervantion/loaderIntervantion.component';


@Component({
  selector: 'app-typemodepassation',
  imports: [UiTable, ModalComponent, ReactiveFormsModule, LoaderComponent, Input, MatIcon, UiButtonComponent, ConfirmDialogComponent, loaderIntervantion  ],
  templateUrl: './typemodepassation.component.html',
  styleUrl: './typemodepassation.component.css'
})
export class TypemodepassationPageComponent implements OnInit {

  constructor(
    private fb: FormBuilder,
    private typeModePassationService: TypeModePassationMarcheService,
    private appService: AppService
  ){
    this.typeModePassationForm = this.fb.group({
      applicationId: this.appService.getAppId(),
      libelle: ['', [Validators.required]],
    });
  }

  public tableTypeModePassation = TableTypeModePassation
  public showAddTypeModePassationModal: boolean = false;
  public typeModePassations : any[] = []
  public isLoading: boolean = false;
  public isEditing: boolean = false; // Nouvelle propriété pour suivre l'état d'édition
  public editingTypeModePassation: any | null = null;
public showDeleteConfirm: boolean = false;
public selectedItem: any | null = null;
public deleteLoading: boolean = false;

  typeModePassationForm!: FormGroup;

  ngOnInit(): void {
    this.loadTypeModePassation();
  }

  saveTypeModePassation(): void {
    if (this.typeModePassationForm.valid) {
      let requestBody: TypeModePassationReq = this.typeModePassationForm.value;
      const code = transformString(requestBody.libelle)
      requestBody = {
        ...requestBody,
        code: code
      }

      this.isLoading = true;
      if (this.isEditing && this.editingTypeModePassation) {
        // Logique de mise à jour
        this.typeModePassationService.update(this.editingTypeModePassation.id, requestBody).subscribe({
          next: () => {
            this.loadTypeModePassation();
            this.closeTypeModePassationModal(); // Appel à la méthode renommée
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur lors de la mise à jour de la ligne budgétaire :', error);
            this.isLoading = false;
          }
        });
      } else {
        // Logique de création existante
        this.typeModePassationService.create(requestBody).subscribe({ // Utilise requestBody
          next: () => {
            this.typeModePassationForm.reset({
              applicationId: this.appService.getAppId(),
              libelle: ''
            });
            this.loadTypeModePassation();
            this.closeTypeModePassationModal(); // Appel à la méthode renommée
            this.isLoading = false;
          },
          error: (error) => {
            console.error('Erreur lors de la création de la ligne budgétaire :', error);
            this.isLoading = false;
          }
        });
      }
    } else {
      this.typeModePassationForm.markAllAsTouched();
      console.warn('Le formulaire de ligne budgétaire est invalide.');
    }
  }

  onEditTypeModePassation(item: any): void {
    this.isEditing = true;
    this.editingTypeModePassation = item;
    this.typeModePassationForm.patchValue({
      libelle: item.libelle,
      applicationId: this.appService.getAppId()
    });
    this.showAddTypeModePassationModal = true;
  }

  openTypeModePassationModal(): void {
    this.isEditing = false; // S'assurer que nous sommes en mode ajout
    this.editingTypeModePassation = null;
    this.typeModePassationForm.reset({
      applicationId: this.appService.getAppId(),
      libelle: ''
    }); // Réinitialiser le formulaire
    this.showAddTypeModePassationModal = true;
  }

  closeTypeModePassationModal(): void {
    this.showAddTypeModePassationModal = false;
    this.isEditing = false; // Réinitialiser l'état d'édition
    this.editingTypeModePassation = null; // Réinitialiser l'élément en édition
    this.typeModePassationForm.reset({
      applicationId: this.appService.getAppId(),
      libelle: ''
    });
  }
  
  // Méthode d'édition
onEditTask(item: any): void {
  this.isEditing = true;
  this.editingTypeModePassation = item;
  this.typeModePassationForm.patchValue({ libelle: item.libelle });
  this.showAddTypeModePassationModal = true;
}

// Remplacer onDeleteTypeModePassation par ces trois méthodes
openDeleteConfirm(item: any): void {
  this.selectedItem = item;
  this.showDeleteConfirm = true;
}

cancelDelete(): void {
  this.showDeleteConfirm = false;
  this.selectedItem = null;
}

confirmDelete(): void {
  if (!this.selectedItem) return;
  this.deleteLoading = true;
  this.typeModePassationService.delete(this.selectedItem.id).subscribe({
    next: () => {
      this.loadTypeModePassation();
      this.deleteLoading = false;
      this.cancelDelete();
    },
    error: (error) => {
      console.error('Erreur suppression :', error);
      this.deleteLoading = false;
    }
  });
}


  onDeleteTypeModePassation(item: any): void {
    this.typeModePassationService.delete(item.code).subscribe(({
      next: () => {
        this.typeModePassationForm.reset({
          applicationId: this.appService.getAppId(),
          libelle: ''
        });
        this.loadTypeModePassation();
        //this.closeAddLigneBudgetaireModal(); // Appel à la méthode renommée
        this.isLoading = false;
      },
      error: (error) => {
        console.error('Erreur lors de la création de la ligne budgétaire :', error);
        this.isLoading = false;
      }
    }))
  }

  loadTypeModePassation(): void {
    const appId = this.appService.getAppId();
    if (!appId) {
      console.warn('TypemodepassationPageComponent: app_id absent — chargement annulé.');
      return;
    }
    this.typeModePassationService.getAllByAppId(appId).subscribe({
      next: (response: any) => {
        this.typeModePassations = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

}
